import React, { useState } from "react";
import { Formik } from "formik";
import { LoginSchema } from "../../validations";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { loginUser } from "../../store/actions";
import { User, Lock, Eye, EyeOff } from "lucide-react";
import { Button } from "../UI";
import "./login.css";
import Logo from "../../assets/ethiologo.png";

const Login = ({ loginUser }: any) => {
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Formik
      initialValues={{ email: "", password: "" }}
      validationSchema={LoginSchema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={(values, { setErrors, setStatus }) => {
        loginUser(values)
          .then((successful: any) => {
            if (successful) {
              history.push("/");
            }
          })
          .catch((err: any) => {
            console.error("[LOGIN] Login attempt failed:", err);
            setErrors(err);
            const globalMessage = err.error || err.message || err.msg || "Invalid email or password.";
            setStatus({ globalError: globalMessage });

          });
      }}
    >
      {({ handleSubmit, handleChange, handleBlur, values, touched, errors, submitCount, status }) => (
        <div className="login-layout text-slate-900">
          <div className="absolute inset-0 bg-slate-800/5 pointer-events-none"></div>
          {/* <div className="absolute inset-0 bg-slate-800/10 pointer-events-none hidden sm:block"></div> */}


          <div className="login-form-container">
            <div className="login-logo">
              <img src={Logo} alt="Logo" />
            </div>
            <h1 className="text-xl font-black text-slate-700 text-center mb-6">Door Access Management</h1>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="space-y-4">

                {/* Email Field */}
                <div className="space-y-1">
                  <div className="tailwind-input-container">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email Address"
                      className="tailwind-input"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="email"
                    />
                    {/* MOVED INSIDE CONTAINER */}
                    {submitCount > 0 && errors.email && (
                      <p className="error-msg">{errors.email as string}</p>
                    )}
                  </div>
                </div>

                {/* Password Field */}
                <div className="space-y-1">
                  <div className="tailwind-input-container">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Password"
                      className="tailwind-input"
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="current-password"
                    />
                    <button
                      type="button"
                      className="input-icon-right"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                    </button>
                    {/* MOVED INSIDE CONTAINER */}
                    {submitCount > 0 && errors.password && (
                      <p className="error-msg">{errors.password as string}</p>
                    )}
                  </div>
                </div>

                {/* Global Error Message */}
                {/* Global Error Message */}
                {/* Global Error Message */}
                {status && status.globalError && (
                  <div className="w-full p-3 bg-rose-50 border border-rose-200/60 rounded-xl text-center">
                    <p className="global-error-text">{status.globalError}</p>
                  </div>
                )}

                <Button
                  type="submit"
                  className="login-form-button"
                  onClick={handleSubmit as any}
                >
                  SIGN IN
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Formik >
  );
};

const mapDispatchToProps = {
  loginUser,
};

const mapStateToProps = (state: any) => ({
  commonError: state.common.errors.error,
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);



